module.exports = __webpack_public_path__ + "img/logo.e53881d2.svg";